// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ecQq","title":"styles_title__3q2Nh"};